<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>师徒列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="服务者编号">
                    <el-input v-model="listQuery.workerNo" placeholder="" clearable></el-input>
                </el-form-item>
                <el-form-item label="徒弟姓名">
                    <el-input v-model="listQuery.workerName" placeholder="" clearable></el-input>
                </el-form-item>
                <el-form-item label="师傅姓名">
                    <el-input v-model="listQuery.mastWorkerName" placeholder="" clearable></el-input>
                </el-form-item>
                        <el-form-item label="状态">
          <el-select v-model="listQuery.isCancel" placeholder="请选择状态" clearable>
            <el-option :value="false" label="保持中"></el-option>
            <el-option :value="true" label="已解除"></el-option>
          </el-select>
        </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-icon-plus" plan @click="addMentor">新增师徒关系</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="masterWorkerNo" label="师傅服务者编号"></el-table-column>
                <el-table-column prop="masterWorkerName" label="师傅姓名"></el-table-column>
                <el-table-column prop="workerNo" label="徒弟服务者编号"></el-table-column>
                <el-table-column prop="workerName" label="徒弟姓名"></el-table-column>
                
               <el-table-column prop="grandMasterWorkerNo" label="师祖服务者编号"></el-table-column>
                <el-table-column prop="grandMasterWorkerName" label="师祖姓名"></el-table-column>

                <el-table-column prop="is_cancel" label="状态">
                    <template slot-scope="scope">
                        <el-tag  type="success"  v-if="scope.row.isCancel==false">保持中</el-tag>
                        <span style=""  v-else>已解除</span>
                    </template>
                </el-table-column>
                              <el-table-column prop="grandMasterWorkerName" label="是否为招招盈">
                                <template slot-scope="scope">
                                    {{scope.row.type?'是':'否'}}
                                </template>
                              </el-table-column>
                <el-table-column prop="is_cancel" label="取消类型">
                    <template slot-scope="scope">
                       <span v-if="scope.row.cancelType==1">离职取消（师傅）</span>
                       <span v-if="scope.row.cancelType==2">离职取消（徒弟）</span>
                       <span v-if="scope.row.cancelType==3">手动取消</span>
                    </template>

                </el-table-column>
                <el-table-column prop="cancelPersonName" label="取消人姓名"></el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                 <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
                 <el-table-column prop="cancelTime" :formatter="dateFormatA" label="取消时间"></el-table-column>

                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="text"  v-if="scope.row.isCancel==false" icon="el-icon-delete" @click="handleDel(scope.$index, scope.row)">取消师徒关系</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="添加师徒关系" :visible.sync="showAdd" width="560px" :close-on-click-modal="false" center >
            <el-form ref="addFrom" :model="addFrom">
                <el-form-item label="师傅">
                    <el-select v-model="addFrom.masterWorkerNo" @change="selectmast" clearable placeholder="请选择" filterable style="width:360px">
                        <el-option v-for="(item,index) in allMentorList" :key="index" :label="item.workerName+'('+item.workerTel+')'" :value="item.workerNo"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="徒弟">
                    <el-select v-model="addFrom.workerNo" clearable placeholder="请选择" filterable style="width:360px">
                        <el-option v-for="(item,index) in allWorkerData" :key="index" :label="item.workerName+'('+item.workerTel+')'" :value="item.workerNo"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="saveRelation('addFrom')">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            isDocumentaryType: {
                0: "否",
                1: "无薪跟单",
                2: "有薪跟单",
            },
            listData: [],

            allWorkerData: [],
            allMentorList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                workerNo:'',
                isCancel:null,
                workerName: null,
                mastWorkerName: null,
            },

            addFrom: {
                masterWorkerNo: null, //师傅
                workerNo: null, //服务者编号
                tempCityId: null, //师傅所在城市
            },

            showUpdate: false,
            showAdd: false,
        };
    },

    created() {
        // this.getAllPostStation();
         if (this.$route.query.workerNo) {
             console.log(this.$route.query);
            this.listQuery.workerNo = this.$route.query.workerNo;
        }

        this.querySearch();
    },
    activated(){
         if (this.$route.query.workerNo) {
             console.log(this.$route.query);
            this.listQuery.workerNo = this.$route.query.workerNo;
        }
    },
    methods: {
        handleDel(index, row) {
            this.$confirm("是否取消师徒关系?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$ajaxemWorkerMentorCancelMentorRelate({
                            id: row.id,
                            updateUserId: globalData.userInfo.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        addMentor() {
            this.showAdd = true;
            this.getMentor();
            this.addFrom = {
                masterWorkerNo: null, //师傅
                workerNo: null, //服务者编号
                tempCityId: null, //师傅所在城市
            };
        },
        saveRelation() {
            if(this.addFrom.masterWorkerNo==null||this.addFrom.masterWorkerNo==''){
                 this.$message.error('请选择师傅');
                return;
            }
              if(this.addFrom.workerNo==null||this.addFrom.workerNo==''){
                 this.$message.error('请选择徒弟');
                return;
            }
            if(this.addFrom.workerNo==this.addFrom.masterWorkerNo){
                 this.$message.error('徒弟与师傅不能是同一人');
                return;
            }

            this.addFrom.createUserId= globalData.userInfo.id;
            crmApi
                .$ajaxemWorkerMentorAddWorkerMentor(this.addFrom)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.$message.success("操作成功");
                        this.showAdd = false;
                        this.querySearch();
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            crmApi
                .$ajaxemWorkerMentorGetPageList(this.listQuery)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.listData = res.data.data.list;
                        this.total = res.data.data.total;
                    }
                });
        },
        selectmast(workerNo) {
            if (workerNo == null || workerNo == "") {
                this.addFrom.tempCityId = null;
                return;
            }
            let cityId=null;
            this.allMentorList.forEach(e=>{
                if(e.workerNo==workerNo){
                    cityId=e.cityId;
                }
            })

            let req = {
                cityId: cityId,
            };
            crmApi.$ajaxWorkerSupplierGetWorker(req).then((res) => {
                if (res.data.errno == 0) {
                    this.allWorkerData = res.data.data;
                }
            });
        },
        getMentor() {
            //获取所有师傅
            crmApi.$ajaxemWorkerMentorGetAllMentor().then((res) => {
                if (res.data.errno == 0) {
                    this.allMentorList = res.data.data;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>